'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTimeout = addTimeout;
exports.createSafeCall = createSafeCall;
function addTimeout(promise) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === undefined ? 60 * 1000 : _ref$timeout,
      _ref$message = _ref.message,
      message = _ref$message === undefined ? 'Timeout: Wix Js Sdk' : _ref$message;

  var error = void 0;
  try {
    throw new Error(message); // to capture stack trace for IE
  } catch (ex) {
    error = ex;
  }

  var timerId = void 0;
  var timeoutPromise = new Promise(function (resolve, reject) {
    timerId = setTimeout(reject, timeout, error);
  });
  var clear = function clear() {
    return clearTimeout(timerId);
  };
  promise.then(clear, clear);
  return Promise.race([promise, timeoutPromise]);
}

function createSafeCall(onError) {
  return function (fn) {
    return function () {
      try {
        return fn.apply(this, arguments);
      } catch (ex) {
        onError(ex);
        return null;
      }
    };
  };
}
//# sourceMappingURL=utils.js.map



//////////////////
// WEBPACK FOOTER
// ../~/js-sdk-wrapper/dist/src/utils.js
// module id = 16
// module chunks = 9 10 11